import { createContext, useContext } from 'react';
import { useWhoami } from '../../stores/org';
import { useStorageInit } from './use-storage-init';
import { StorageConnection } from '@cotera/client/v0/models/user-branches';

const StorageContext = createContext<StorageConnection | null>(null);

export const useStorage = () => {
  return useContext(StorageContext)!;
};

export const SuspensefulStorageProvider: React.FC<{
  children: React.ReactNode;
}> = ({ children }) => {
  const org = useWhoami((s) => s.org);
  const { data: storageData } = useStorageInit(org);

  return (
    <StorageContext.Provider value={storageData.storage}>
      {children}
    </StorageContext.Provider>
  );
};
